import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Process from './views/Process.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: 'Home',
      },
    },
    {
      path: '/process',
      name: 'process',
      component: Process,
      meta: {
        title: 'Process',
      },
    },
  ],
});
